import { render, staticRenderFns } from "./WishSampleConfig.vue?vue&type=template&id=47b970fc&scoped=true"
import script from "./WishSampleConfig.vue?vue&type=script&lang=js"
export * from "./WishSampleConfig.vue?vue&type=script&lang=js"
import style0 from "./WishSampleConfig.vue?vue&type=style&index=0&id=47b970fc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b970fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47b970fc')) {
      api.createRecord('47b970fc', component.options)
    } else {
      api.reload('47b970fc', component.options)
    }
    module.hot.accept("./WishSampleConfig.vue?vue&type=template&id=47b970fc&scoped=true", function () {
      api.rerender('47b970fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/WishSampleConfig.vue"
export default component.exports